document.addEventListener('DOMContentLoaded', function() {
    console.log('Base JS loaded');
    const $productDetails = document.querySelectorAll('.product-template__additional-details');

    if ($productDetails) {
        $productDetails.forEach($details => {
            // Detail triggers
            const $triggers = $details.querySelectorAll('.product-detail__trigger');
            const $contents = $details.querySelectorAll('.product-detail__content');
            
            $triggers.forEach(($trigger) => {
                $trigger.addEventListener('click', function() {
                    const type = this.getAttribute('data-type');

                    // remove active state from other triggers
                    $triggers.forEach(($btn) => {
                        $btn.classList.remove('active');
                    });

                    // set active state to clicked trigger
                    this.classList.add('active');

                    // show/hide contents based on type
                    $contents.forEach(($content) => {
                        if ($content.getAttribute('data-type') === type) {
                            $content.classList.add('active');
                        } else {
                            $content.classList.remove('active');
                        }
                    });
                });
            });

            // Detail accordions
            const $accordionsContainer = $details.querySelector(".product-detail-accordions");

            if ($accordionsContainer){
                const $accordions = $accordionsContainer.querySelectorAll(".product-detail__accordion");

                $accordions.forEach($accordion => {
                    const $accordionTrigger = $accordion.querySelector(".product-detail__accordion-trigger");

                    $accordionTrigger.addEventListener("click", () => {
                        // Close other accordions
                        $accordions.forEach($currentAccordion => {
                            if ($currentAccordion != $accordion){
                                $currentAccordion.classList.remove("active");
                            }
                        });
                        // Toggle clicked accordion
                        $accordion.classList.toggle("active");
                    });
                });
            }
        });
    }

    // const $price = document.querySelector('#productPrice');
    // const $money = $price.querySelector('.theme-money');
    // console.log('price: ', $price.dataset.price);
    // console.log('money: ', $money);
    // console.log('qty', document.querySelector('.qty-actual__input'));

    // const $tawkTriggers = document.querySelectorAll(".tawk-trigger");

    // if ($tawkTriggers){
    //     console.log("tawk init");
    //     $tawkTriggers.forEach($trigger => {
    //         $trigger.addEventListener("click", () => {
    //             const $tawkButton = document.querySelector(".tawk-button");
    //             console.log('click tawk: ', $tawkButton);
    //             $tawkButton.click();
    //         });
    //     });
    // }
});
